import {Alert} from '@mui/material';
import React from 'react';

const ErrorMessage = ({error, ...rest}) => (
  <Alert severity="error" variant={'outlined'} {...rest}>
    {error}
  </Alert>
);

export default ErrorMessage;
